import {applyMiddleware, createStore} from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import {createLogger} from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import storage from 'redux-persist/es/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import {appReducer} from './stores';
import {persistStore, persistReducer} from 'redux-persist';

const persistConfig = {
   key: 'root',
   storage,
   storageReconciler: autoMergeLevel2,
   whitelist: ['apiSelectionParam']
};

const persistedReducer = persistReducer(persistConfig, appReducer);

const middlewares = [thunk, promise];

if (process.env.NODE_ENV === `development`) {
   // In development, we add redux-logger
   middlewares.push(createLogger({collapsed: true}));
}

export const store = createStore(
   persistedReducer,
   composeWithDevTools(applyMiddleware(...middlewares)),
);

export const persistor = persistStore(store);
